export const stats = [
  { value: '+100', label: 'Unités Prêtes' },
  { value: '+2 000', label: 'Profs Satisfaits' },
  { value: '4 200+', label: 'Heures Gagnées' },
  { value: '99%', label: 'Taux de Recommandation' },
]

export const differenceStats = [
  { value: '+100', label: 'Séances prêtes (du CP à la 3ème)' },
  { value: '9', label: 'Volumes Numériques Complets' },
  { value: '100%', label: 'Téléchargeable Immédiatement' },
]

export const beforeItems = [
  "Des heures à préparer chaque séance d'Arts Plastiques",
  'Des exercices répétitifs et des photocopies ternes',
  "Aucun lien concret avec l'Histoire de l'Art",
  'Ne pas savoir comment noter ou évaluer objectivement',
  'Des élèves démotivés qui « n\u2019aiment pas le dessin »',
]

export const afterItems = [
  '5 minutes de révision et vous êtes prêt',
  'Projets visuels et stimulants pour les élèves',
  'Applications réelles et culturelles intégrées',
  'Quiz, examens et grilles d\u2019évaluation prêts',
  'Des élèves qui créent avec une confiance absolue',
]

export const recognizeItems = [
  {
    emoji: '😰',
    label: 'L’angoisse',
    text: 'Arriver en classe sans savoir exactement comment expliquer une notion technique complexe',
  },
  {
    emoji: '⏱️',
    label: 'Le sacrifice',
    text: 'Passer votre dimanche entier à planifier ce qui devrait prendre quelques minutes',
  },
  {
    emoji: '🤷',
    label: 'La galère',
    text: 'Chercher désespérément des fiches d’activité vraiment visuelles et de haute qualité',
  },
  {
    emoji: '📋',
    label: 'Le flou',
    text: 'N’avoir aucune évaluation ou grille de notation alignée sur le programme scolaire',
  },
  {
    emoji: '😴',
    label: 'Le décrochage',
    text: 'Voir les élèves prendre du retard car le matériel n’est pas adapté à leur niveau',
  },
  {
    emoji: '🌙',
    label: 'Le stress',
    text: 'Toujours pas prêt pour lundi alors que le dimanche soir touche à sa fin',
  },
]

export const packItems = [
  {
    emoji: '📚',
    title: '9 Volumes par Niveaux (CP à 3ème)',
    text: 'Un cursus complet, de l’éveil en primaire aux projets complexes du collège',
  },
  {
    emoji: '🏛️',
    title: 'Volume 9 : Le Plan de Maîtrise',
    text: 'Le système d’exploitation du prof : grilles d’évaluation, calendriers et fiches de suivi',
  },
  {
    emoji: '✏️',
    title: 'Scripts de Cours Pas-à-Pas',
    text: 'Des instructions « enseignant » qui vous disent exactement comment mener la séance',
  },
  {
    emoji: '📐',
    title: 'Grammaire Visuelle & Fiches',
    text: 'Des graphiques HD qui rendent perspective, ombre et couleur simples à comprendre',
  },
  {
    emoji: '📊',
    title: 'Bilans & Examens Finaux',
    text: 'Des outils d’évaluation complets pour chaque cycle scolaire',
  },
  {
    emoji: '🔑',
    title: 'Corrigés Complets',
    text: 'La notation devient enfin instantanée, précise et sans stress',
  },
]

export const instantItems = [
  'Les 9 volumes numériques complets (Série Primaire + Série Collège)',
  'Activités, défis et projets par cycle pédagogique',
  'Leçons visuelles pour chaque concept artistique',
  'Scripts « enseignant » pour savoir exactement quoi dire',
  'Corrigés pour chaque fiche et examen du système',
]

export const bonuses = [
  {
    title: 'Le Kit « Atelier Zéro Chaos »',
    subtitle: 'Organisation et gestion du matériel',
    was: '17 €',
    cover:
      'https://cdn.magicpatterns.com/patterns/generated-images/63a4dd1d-35e9-417b-ab9b-c7e29a2182d6.jpg',
  },
  {
    title: 'Banque de « Warm-ups » (5 min)',
    subtitle: '100 amorces rapides pour lancer le cours',
    was: '14 €',
    cover:
      'https://cdn.magicpatterns.com/patterns/generated-images/d31b80b0-0531-4685-82d0-bb603929aa24.jpg',
  },
  {
    title: 'Le Système de Feedback Automatisé',
    subtitle: '50 modèles de commentaires',
    was: '9 €',
    cover:
      'https://cdn.magicpatterns.com/patterns/generated-images/ffe5490d-b0aa-4b9d-be12-958b4c7df42c.jpg',
  },
  {
    title: 'Le Kit d’Urgence « Remplacement »',
    subtitle: 'Séances autonomes pour vos absences',
    was: '17 €',
    cover:
      'https://cdn.magicpatterns.com/patterns/generated-images/41b0e49f-3957-498f-b650-51b57c2eb04e.jpg',
  },
  {
    title: 'Supports Visuels HD pour TNI/VPI',
    subtitle: 'Assets haute résolution',
    was: '19 €',
    cover:
      'https://cdn.magicpatterns.com/patterns/generated-images/5e735ada-6df1-4049-b966-e8228ba6e385.jpg',
  },
]

export const offerRows = [
  { label: 'Pack ARTS PRÊT™ (9 Volumes Numériques)', value: '77 €' },
  { label: '5 Bonus Stratégiques Exclusifs', value: '76 €' },
]

export const testimonials = [
  {
    quote:
      'J’ai enfin retrouvé mes dimanches. La progression du CP à la 3ème est exactement ce qu’il me fallait.',
    name: 'Isabelle G.',
    location: 'France 🇫🇷',
  },
  {
    quote:
      'Les cartes de grammaire visuelle font une énorme différence pour mes élèves qui avaient du mal avec la perspective.',
    name: 'Marc L.',
    location: 'Belgique 🇧🇪',
  },
  {
    quote:
      'Rien que les modèles de feedback automatisés ont sauvé ma santé mentale cette année. Ça vaut chaque centime.',
    name: 'Sophie R.',
    location: 'Suisse 🇨🇭',
  },
]

export const faqs = [
  {
    q: 'Comment je reçois le matériel ?',
    a: 'Par email, immédiatement après votre commande. Vous recevez un lien de téléchargement pour accéder à tous les fichiers PDF et numériques.',
  },
  {
    q: 'Est-ce que ça fonctionne pour un prof débutant ?',
    a: 'Oui, c’est un système complet conçu pour vous guider. Les scripts vous disent exactement quoi faire dès la première séance.',
  },
  {
    q: 'Quels niveaux sont couverts ?',
    a: 'Du CP (primaire) jusqu’à la 3ème (fin du collège), avec des séances adaptées à chaque cycle.',
  },
  {
    q: 'Est-ce un paiement mensuel ?',
    a: 'Non, c’est un paiement unique pour un accès illimité à vie. Aucun frais caché, aucun abonnement.',
  },
]
